import { makeVar } from '@apollo/client';

import { AthleteI } from 'types';

export const athleteFinancialCardRotatedVar = makeVar<Record<AthleteI['id'], boolean>>({});
export const athleteFinancialCardClosedVar = makeVar<Record<AthleteI['id'], boolean>>({});
export const isTradeBarOpened = makeVar<boolean>(true);
export const isTickerBarOpened = makeVar<boolean>(false);
export const isAccountProfileOpened = makeVar<boolean>(false);
